// extracted by mini-css-extract-plugin
module.exports = {"shapeSelector":"ShapeSelector_shapeSelector__2IGxN","fillRadio":"ShapeSelector_fillRadio__1OuIF","buttonGroup":"ShapeSelector_buttonGroup__3S1vw"};